import "./banner.css";

import {
  faCalendarMinus,
  faCheck,
  faExclamationTriangle,
  faNotesMedical,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

export interface BannerProps {
  type?: "message" | "alert" | "maintenance" | "note" | "resolved";
  children?: ReactNode;
}

const BannerIcon = ({ type }: Partial<BannerProps>) => {
  switch (type) {
    case "maintenance":
      return <FontAwesomeIcon icon={faCalendarMinus} />;
    case "note":
      return <FontAwesomeIcon icon={faNotesMedical} />;
    case "resolved":
      return <FontAwesomeIcon icon={faCheck} />;
    default:
      return <FontAwesomeIcon icon={faExclamationTriangle} />;
  }
};

const Banner = ({ type, children }: BannerProps) => {
  return (
    <div className={`Banner Banner--${type}`}>
      <p>
        <span>
          <BannerIcon type={type} />
        </span>
        {children}
      </p>
    </div>
  );
};

export default Banner;
